import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { forkJoin } from 'rxjs';
import { Folder } from '../../models/folder';
import { snack, snackErr } from '../../modules/snack.module';
import { FolderService } from '../../services/folder/folder.service';
import { UserService } from '../../services/user/user.service';
import { SelectFieldComponent } from '../select-field/select-field.component';
import { t } from '../translate/translate.function';
import { TranslateModule } from '../translate/translate.module';

@Component({
  selector: 'apex-field-dialog',
  templateUrl: './field-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    TranslateModule,
    MatDialogContent,
    MatButton,
    MatDialogActions,
    SelectFieldComponent,
  ],
  providers: [FolderService, UserService],
})
export class FieldDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Folder,
    public ref: MatDialogRef<FieldDialogComponent>,
    private folderService: FolderService,
  ) {}

  folder: Folder;
  parentFolder: Folder;
  fieldId: number = null;

  ngOnInit(): void {
    forkJoin({
      parentFolder: this.folderService.get(this.data.ParentId),
      folder: this.folderService.get(this.data.id),
    }).subscribe(({ parentFolder, folder }) => {
      this.parentFolder = parentFolder.Entity;
      this.folder = folder.Entity;
    });

    this.ref?.addPanelClass(['apex-fullscreen-dialog', 'phone']);
  }

  emitFieldId(fieldId: number): void {
    this.fieldId = fieldId;
  }

  async save(): Promise<void> {
    const payload = {
      ...this.folder,
      FieldId: this.fieldId,
    };

    this.folderService.update(this.folder.id, payload).subscribe({
      next: () => {
        this.ref.close();
        snack(t('Saved successfully'));
      },
      error: (err) => {
        snackErr(t('Failed to save'), err);
      },
    });
  }
}
